import { Chord, ChordType } from '@tonaljs/tonal';
import React, { Fragment } from 'react';

import AbcNotation from 'components/abc-notation';
import { PageTitle } from '../components';
import { Table } from 'react-bulma-components';

export default function Chords() {
  return (
    <Fragment>
      <PageTitle name="Chord Definitions" description="All scales and more ..." />
      <Table striped={true} size="fullwidth">
        <thead>
          <tr><th>Chord type</th><th>Aliases</th><th>Intervals</th></tr>
        </thead>
        <tbody>
          {ChordType.all()
            .map((chordType, index) =>
              <tr key={index}>
                <td>{chordType.name}</td><td>{chordType.aliases.join(', ')}</td><td>{chordType.intervals.join(' ')}<br />{Chord.getChord(chordType.aliases[0], "C4").notes}<br />
                  <div style={{ width: 250 }}><AbcNotation scientificNotes={Chord.getChord(chordType.aliases[0], "C4").notes} /></div>
                </td>
              </tr>
            )
          }
        </tbody>
      </Table>

    </Fragment>
  );
}
